module.exports = __webpack_public_path__ + "img/川木通.883eb0d2.jpg";